import React, { useState, useEffect, useRef } from 'react';
import './CopilotEllipsisText.css';
import CommonBubble from '@home/components/CommonBubble';

interface ICopilotEllipsisTextProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string;
  suffix?: React.ReactNode;
  maxLines?: number; // 最大行数
  lineHeight?: number; // 行高，默认为1.5em
}

const CopilotEllipsisText = ({
  text,
  suffix = '更多',
  maxLines = 2,
  lineHeight = 1.5, // 默认行高为1.5em
  ...props
}: ICopilotEllipsisTextProps) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const [isHoverChartTitle, setIsHoverChartTitle] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkTruncation = () => {
      if (!contentRef.current) return;

      // 重置样式以测量原始高度
      contentRef.current.style.display = 'block';
      contentRef.current.style.webkitLineClamp = 'unset';
      // contentRef.current.textContent = text;

      // 计算容器最大高度（行高 × 行数）
      const maxHeight = lineHeight * maxLines;
      contentRef.current.style.maxHeight = `${maxHeight}em`;

      // 检查是否需要截断
      const needsTruncation =
        contentRef.current.scrollHeight > contentRef.current.clientHeight;
      setIsTruncated(needsTruncation);

      if(needsTruncation){
        contentRef.current.style.display = '-webkit-box';
        contentRef.current.style.webkitLineClamp = maxLines.toString();
      }
    };

    checkTruncation();
    window.addEventListener('resize', checkTruncation);

    return () => {
      window.removeEventListener('resize', checkTruncation);
    };
  }, [text, maxLines, lineHeight]);

  return (
    <CommonBubble
      placement="top"
      closeOnScroll
      destroyOnClose
      content={text}
      visible={isTruncated && isHoverChartTitle}
      className='dba-source-bubble-box'
      overlayClassName='dba-nav-menu-overlay'
    >
      <div className="ellipsis-container" {...props}>
        <div
          className="ellipsis-content"
          ref={contentRef}
          style={{
            lineHeight: `${lineHeight}em`,
            whiteSpace: 'normal',
          }}
          onMouseEnter={() => setIsHoverChartTitle(true)}
          onMouseLeave={() => setIsHoverChartTitle(false)}
        >
          {text}
          {!isTruncated && <span>{suffix}</span>}
        </div>
        
        {isTruncated && (
          <span
            className="ellipsis-suffix"
            style={{
              position: 'absolute',
              left: contentRef.current!.getBoundingClientRect().width,
              background: 'inherit', // 继承背景色
            }}
          >
            {suffix}
          </span>
        )}
      </div>
    </CommonBubble>
  );
};

export default CopilotEllipsisText;
